export default __webpack_public_path__ + "static/media/about.b6aa65c4.svg";